import LoginComponent from "../components/LoginComponent"

export const LoginView = () => {
  return (<LoginComponent />)
}
